import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import NotificationList from "./NotificationConfigureList";
import TopicList from "./TopicList";
import "../../views/Wallet/index.scss";
import Heading from "../../components/Heading";

import useCustomNavigate from "../../components/customNavigationHook";

const NotificationManagement = () => {
  const [activeTab, setActiveTab] = useState("1");
  const navigate = useCustomNavigate();
  useEffect(() => {
    if (history?.state?.usr?.currentTab) {
      setActiveTab(history?.state?.usr?.currentTab);
    }
  }, [history]);

  const items = [
    {
      key: "1",
      label: "Notification",
      children: <NotificationList />,
    },
    {
      key: "2",
      label: "Topic",
      children: <TopicList />,
    },
  ];

  const changeKey = (key) => {
    setActiveTab(key);
    navigate(location.pathname, {
      state: { currentTab: key },
      replace: true, // This prevents re-navigation but updates state
    });
  };
  return (
    <div className="master-main-container p-1">
      <Heading title={"Notification"} />
      <Tabs
        defaultActiveKey="1"
        activeKey={history?.state?.currentTab || activeTab}
        items={items}
        className="wallet-tabs mt-1"
        onChange={(key) => {
          changeKey(key);
        }}
      />
    </div>
  );
};

export default NotificationManagement;
